import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useI18n } from "../domain/i18n";
import { SlideshowItem } from "../domain/slideshow";

interface CoverSlideshowProps {
  items: Array<SlideshowItem>;
}

export default function CoverSlideshow({ items }: CoverSlideshowProps) {
  const I18n = useI18n();

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      loop={true}
      speed={1000}
      autoplay={{
        delay: 10000,
        disableOnInteraction: false,
      }}
      navigation={{
        prevEl: ".cover-slideshow__previous",
        nextEl: ".cover-slideshow__next",
      }}
      pagination={{
        el: ".cover-slideshow__pagination",
        clickable: true,
        bulletClass: "cover-slideshow__pagination__item",
        bulletActiveClass: "is-active",
      }}
      style={{ height: "100vh", background: "#24195D" }}
    >
      {items.map((item, i) => (
        <SwiperSlide key={i}>
          <div className="cover-slideshow__slide" style={{ width: "100vw", height: "100vh" }}>
            <div
              className="cover-slideshow__slide__background"
              style={{ backgroundImage: `url("${item.imgSrcLarge}")` }}
            />
            <div
              className="cover-slideshow__slide__content"
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <h1>{item.title}</h1>
              <section dangerouslySetInnerHTML={{ __html: item.body }} />
            </div>
          </div>
        </SwiperSlide>
      ))}
      <span className="cover-slideshow__previous" style={{ zIndex: 2 }}>
        <i className="icon icon-arrow-left" />
      </span>
      <span className="cover-slideshow__next" style={{ zIndex: 2 }}>
        <i className="icon icon-arrow-right" />
      </span>
      <div className="cover-slideshow__pagination" />
      <a href="#scroll-section-1" className="landing-page__cover__scroll" data-scroll>
        {I18n.t("home.scroll-indicator")}{" "}
        <div className="landing-page__cover__scroll__indicator scroll-indicator"></div>
      </a>
    </Swiper>
  );
}
